
export default {
    props: {
        client: {
            type: Object,
            default: null
        },
        forGroup: {
            type: [Object, Number],
            default: null
        },
        autoAdvance: {
            type: Boolean,
            default: false
        },
        aep: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            allowed_methods: null,
            checking: false,
        }
    },
    computed: {
        hasMethods () {
            return this.allowed_methods && this.allowed_methods.length > 0
        },
        groupId () {
            return typeof this.forGroup === 'object' ? this.forGroup?.id : this.forGroup
        },
    },
    mounted () {
        return this.check()
    },
    methods: {
        async check () {
            if (this.surveyModel?.lastDirection === -1) {
                this.previous()
            } else {
                if (this.client.source_type === 'DOCTOR_CHOICE_INTERNAL') {
                    this.allowed_methods = this.aep ? ['email', 'phone', 'survey'] : ['email', 'phone', 'video']
                    this.$emit('set-value', { key: 'allowed_methods', value: this.allowed_methods })
                    if (this.autoAdvance) {
                        console.log('Auto advancing to next step after setting allowed methods for Direct Primary Care')
                        this.next()
                    }
                    return
                }
                if (!this.groupId) {
                    this.allowed_methods = []
                    this.$emit('set-value', { key: 'allowed_methods', value: this.allowed_methods })
                    return
                }
                this.checking = true
                this.allowed_methods = await this.$api.getGroupSchedulingMethods(
                    typeof this.forGroup === 'object' ? this.forGroup?.id : this.forGroup,
                    { aep: this.aep, user_id: this.client?.id }
                )
                this.$emit('set-value', { key: 'allowed_methods', value: this.allowed_methods })
                this.checking = false
                if (this.autoAdvance && this.hasMethods) {
                    this.next()
                }
            }
        },
        gtfo () {
            if (this.surveyModel?.lastDirection === -1) {
                this.previous()
            } else {
                this.next()
            }
        },
        previous () {
            // eslint-disable-next-line no-constant-condition
            if (this.surveyModel) {
                this.surveyModel.prevPage()
            } else {
                // todo: i know i know this will never reach,
                // but it's not working anyways, event is not reaching vcomponent vm.$on('previous', handler)
                this.$emit('previous')
            }
        },
        next () {
            if (this.surveyModel) {
                this.surveyModel.nextPage()
            } else {
                this.$emit('next')
            }
        }
    }
}
